import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Spin,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import { useNavigate, useParams } from 'react-router-dom';
import { MdDelete, MdPayment } from 'react-icons/md';
import { PlusOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getAccounts } from '../../../network/ChartAccount';
import {
  addModeOfPayment,
  getModeOfPaymentById,
  updateModeOfPayment,
} from '../../../network/ModeOfPayments';
import { getModeOfPayments } from '../../../network/PaymentEntry';
import { getSearchApi, getSearchApiAcount } from '../../../network/itemList';
import HeadingApp from '../../../hooks/HeadingApp';

const ModeOfPaymentAdd = ({ t, edit }) => {
  const client = useQueryClient();
  const { id } = useParams();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [searchTxt, setSearchTxt] = useState('');
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { mutate: onAddModeOfPayment } = useMutation({
    mutationKey: ['addModeOfPayment'],
    mutationFn: (body) =>
      edit ? updateModeOfPayment(body, id) : addModeOfPayment(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({ queryKey: [queryKeys.getModeOfPayments] });

      form.resetFields();
      navigate('/modeofpayments');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      // message.error(error);
    },
  });
  const { data: modeOfPayment, isLoading } = useQuery({
    queryKey: [queryKeys.getModeOfPayments, id],
    queryFn: () => getModeOfPaymentById(id),
    enabled: !!id,
  });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount, searchTxt],
    queryFn: () =>
      getSearchApiAcount({ type: 'Account', searchTxt: searchTxt }),
    enabled: searchTxt?.length >= 3 || searchTxt?.length === 0,
    keepPreviousData: true,
  });

  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddModeOfPayment({
      ...values,
      accounts: values?.accounts[0]?.default_account ? values?.accounts : [],
    });
  };
  useEffect(() => {
    if (modeOfPayment?.data) {
      form.setFieldsValue({
        ...modeOfPayment?.data,
        accounts: modeOfPayment?.data?.accounts?.length
          ? modeOfPayment?.data?.accounts
          : [{}],
      });
    }
  }, [modeOfPayment, form]);
  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="mode-of-payment-add">
      {/* <Heading
        title={t.ModeofPayment}
        subTitle={t.CreateModeOfPayment}
        path="/modeofpayments"
      /> */}
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.ModeofPayment}
        subTitle={edit ? t.editModeOfPayment : t.CreateModeOfPayment}
        icon={<MdPayment />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <h4 className="title-card">{t.Entermodeofpaymentinformation}</h4>
        <Form
          layout="vertical"
          name="mode-of-payment-form"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...modeOfPayment?.data,
                  accounts:
                    modeOfPayment?.data?.accounts?.length > 0
                      ? modeOfPayment?.data?.accounts
                      : [{}],
                }
              : { accounts: [{}] }
          }
        >
          {/* <Divider orientation="left">{t.ModeofPaymentInformation}</Divider> */}
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="mode_of_payment"
                    label={t.ModeofPayment}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.ModeofPayment} disabled={edit} />
                    {/* <Select
                  placeholder={t.ModeofPayment}
                  onChange={handleModeOfPaymentChange}
                  options={modeOfPayments?.message?.mode_of_payments?.map(
                    (appointment) => ({
                      value: appointment?.name,
                      label: appointment?.mode_of_payment,
                      data: appointment,
                    })
                  )}
                /> */}
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="type"
                    label={t.type}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.type}
                      options={[
                        { value: 'Cash', label: t.cash },
                        { value: 'Bank', label: t.Bank },
                        { value: 'General', label: t.General },
                        { value: 'Phone', label: t.InternalSend },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="custom_zatca_payment_means_code"
                    label={t.zatca_payment_means_code}
                    // label={t.name}
                    rules={[{ required: true }]}
                  >
                    <Input
                      type="number"
                      placeholder={t.zatca_payment_means_code}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start',
                  }}
                >
                  <Form.Item
                    name="enabled"
                    // label={t.enabled}
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.enabled}</Checkbox>
                  </Form.Item>
                </Col>
                <Divider orientation="left">{t.Accounts}</Divider>
                <Col span={24}>
                  {/* <Form.Item
                name={['accounts']}
                label={t.DefaultAccount}
                style={{ width: '100%', marginBottom: '0px' }}
              >
                <Select
                  placeholder={t.DefaultAccount}
                  style={{ width: '100%' }}
                  options={accounts?.message?.accounts?.map((item) => ({
                    // value: item?.name,
                    // label: item?.account_name,
                    value: item?.name,
                    label: item?.account_name,
                  }))}
                />
              </Form.Item> */}
                  <Form.List name="accounts" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields?.map(({ key, name, ...restField }) => (
                          <Flex>
                            <Form.Item
                              name={[name, 'default_account']}
                              label={t.DefaultAccount}
                              style={{ width: '100%', marginBottom: '0px' }}
                              // rules={[{ required: true }]}
                              {...restField}
                            >
                              <Select
                                placeholder={t.DefaultAccount}
                                style={{ width: '100%' }}
                                onSearch={(value) => {
                                  setSearchTxt(value);
                                }}
                                filterOption={false}
                                showSearch
                                allowClear
                                onClear={() => {
                                  setSearchTxt('');
                                }}
                                onChange={() => {
                                  setSearchTxt('');
                                }}
                                options={account?.message?.map((item) => ({
                                  value: item?.value,
                                  label: item?.value,
                                }))}
                              />
                            </Form.Item>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '15px',
                                margin: '0 10px',
                              }}
                            ></div>
                          </Flex>
                        ))}
                      </>
                    )}
                  </Form.List>
                </Col>
              </Row>
              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => navigate('/modeofpayments')}
                >
                  {t.Cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default ModeOfPaymentAdd;
